import { render } from "./SomethingElse.vue?vue&type=template&id=5b8bc7f0&scoped=true"
import script from "./SomethingElse.vue?vue&type=script&lang=js"
export * from "./SomethingElse.vue?vue&type=script&lang=js"

import "./SomethingElse.vue?vue&type=style&index=0&id=5b8bc7f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\quinn\\codebase\\personal-site-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8bc7f0"]])

export default __exports__